import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

const ChartComponent = ({ symbol, data, color = '#d4a054' }) => {
  const chartContainerRef = useRef();
  const chartRef = useRef();
  const seriesRef = useRef();

  useEffect(() => {
    if (!chartContainerRef.current) return;

    // Initialize chart
    chartRef.current = createChart(chartContainerRef.current, {
      layout: {
        background: { color: 'transparent' },
        textColor: '#c8bdd9',
      },
      grid: {
        vertLines: { color: 'rgba(212,160,84,0.05)' },
        horzLines: { color: 'rgba(212,160,84,0.05)' },
      },
      width: chartContainerRef.current.clientWidth,
      height: 400,
      timeScale: {
        borderColor: 'rgba(212,160,84,0.2)',
        timeVisible: true,
        secondsVisible: false,
      },
    });

    // Create candlestick series
    seriesRef.current = chartRef.current.addCandlestickSeries({
      upColor: '#10b981',
      downColor: '#ef4444',
      borderVisible: false,
      wickUpColor: '#10b981',
      wickDownColor: '#ef4444',
    });

    // Format data for Lightweight Charts: { time: timestamp, open, high, low, close }
    const formattedData = data.map(c => ({
      time: c.time / 1000, // Convert to seconds
      open: c.open,
      high: c.high,
      low: c.low,
      close: c.close,
    }));

    seriesRef.current.setData(formattedData);

    const handleResize = () => {
      chartRef.current.applyOptions({ width: chartContainerRef.current.clientWidth });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chartRef.current.remove();
    };
  }, []);

  useEffect(() => {
    if (seriesRef.current && data) {
      const lastCandle = data[data.length - 1];
      if (lastCandle) {
        seriesRef.current.update({
          time: lastCandle.time / 1000,
          open: lastCandle.open,
          high: lastCandle.high,
          low: lastCandle.low,
          close: lastCandle.close,
        });
      }
    }
  }, [data]);

  return <div ref={chartContainerRef} className="w-full h-full" />;
};

export default ChartComponent;
